var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLinkedinShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#006EA7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 44.0609C19.25 44.4328 19.5688 44.7516 19.9406 44.7516H24.8813C25.2531 44.7516 25.5719 44.4328 25.5719 44.0609V27.6984C25.5719 27.3266 25.2531 27.0078 24.8813 27.0078H19.9406C19.5688 27.0078 19.25 27.3266 19.25 27.6984V44.0609Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7559 26.8477C37.3652 26.8477 35.6652 27.8039 34.7621 28.8133C34.5496 29.0258 34.1777 28.8664 34.1777 28.5477V27.6977C34.1777 27.3258 33.859 27.007 33.4871 27.007H28.4934C28.1215 27.007 27.8027 27.3258 27.8027 27.6977C27.8559 30.7258 27.8027 41.1914 27.8027 44.007C27.8027 44.3789 28.1215 44.6977 28.4934 44.6977H33.5402C33.9121 44.6977 34.2309 44.3789 34.2309 44.007V35.1352C34.2309 34.6039 34.2309 34.0727 34.3902 33.7008C34.8152 32.6383 35.7715 31.5227 37.4184 31.5227C39.5965 31.5227 40.6059 33.1695 40.6059 35.5602V44.007C40.6059 44.3789 40.9246 44.6977 41.2965 44.6977H46.2371C46.609 44.6977 46.9277 44.3789 46.9277 44.007V34.8695C46.8746 29.3977 43.7402 26.8477 39.7559 26.8477Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3844 25.0406C24.4031 25.0406 25.625 23.7656 25.625 22.1719C25.5719 20.4719 24.4031 19.25 22.4375 19.25C20.4719 19.25 19.25 20.4719 19.25 22.1187C19.25 23.7656 20.4719 25.0406 22.3844 25.0406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinkedinShare);
export default __webpack_public_path__ + "static/media/icon-linkedin-share.b822cb45acb7a3fed25d525782669ebf.svg";
export { ForwardRef as ReactComponent };